export const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
};
export const getFontFamily = () => {
    return window
        .getComputedStyle(document.documentElement)
        .getPropertyValue('--SG_FONT_FAMILY')
        .trim();
};
export const isTouchDevice = () => {
    // The same rule as for styles (see Sass varibale $SG_MQ_TOUCH)
    return window.matchMedia('(pointer: coarse)').matches;
};
//# sourceMappingURL=utils.js.map